import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Form from 'component/newCommonReport/Form'

import Button from 'component/Button'

import DownloadSVG from 'images/download.svg'
import DownloadGraySVG from 'images/download_gray.svg'
import FilterSVG from 'images/filter.svg'
import CloseSVG from 'images/close-icon.svg'
import GeralVisionSVG from 'component/analyticsNew/BackToGeralVision'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import { browserHistory } from 'react-router'
import 'react-resizable/css/styles.css'
import 'styles/overwrittenAndNew/commonReport.css'
import './newreport.css'
import * as spinnerActions from 'action/spinner'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import NewRelatoryTable from 'component/tableRelatoryNew/NewTable'
import SizeSelect, {components} from 'react-select'
import { colourStyles } from 'utils/selectStyle'
import NewPagination from 'component/pagination/newPagination'
import { isEmpty } from 'utils/validations'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import moment from 'moment'
import GraphSVG from 'component/svgComponents/graph'
import TableSVG from 'component/svgComponents/table'

const PAGINATION_OPTIONS = [
  { label: '5', value: 5 },
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '30', value: 30 },
  { label: '40', value: 40 },
]
const WRAPPER_TABLE_RELATORY_STYLES = {
  marginLeft: "20px",
  marginRight: "20px",
  paddingLeft: "16px",
  paddingRight: "16px",
  backgroundColor: "white",
  paddingBottom: "10px",
  overflow: "hidden",
  boxShadow: "0 12px 22px -8px rgba(60, 55, 56, .3)",
  borderRadius: "12px",
  marginBottom: "10px",

  maxHeight: "100%"
}

const DropdownIndicator = props => (
    <components.DropdownIndicator {...props}>
      <DropdownArrow />
    </components.DropdownIndicator>
  )

class CommonReport extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()

    this.state = {
      shadowWidth: 0,
      showTable: props.showTable,
      showFilters: false,
      response: {},
      lines: [],
      dataList: [],
      linesFixed: [],
      headers: [],
      order: false,
      orderDirection: props.analyticsDetails ? 'desc' : 'asc',
      orderField: false,
      page: 1,
      pages: 0,
      limit: 10,
      optionSize: 10,
      formData: {},
      dateStart: "",
      dateEnd: "",
      lastScroll: 0,
      noDataHeight: 0,
      showGraph: false,
      firstFetch: false,
      firstSubmit: false,

      analyticsOptions: [
        {name: this.props.translate('analytics.per.store'), isActive: true, value: 'store'},
        {name: this.props.translate('analytics.per.LDAP'), isActive: false, value: 'ldap'},
        {name: this.props.translate('analytics.per.mission'), isActive: false, value: 'mission'}]
    }
  }

  componentDidMount() {
    const { onSubmit, showTable, fitTableInScreen, submitOnRender, emptyBranchs = false} = this.props

    this.checkProps()
    const noDataHeightDimensionSmall = (window.innerHeight * 70) / 100
    this.setState({noDataHeight: noDataHeightDimensionSmall})

    if (showTable && !submitOnRender) onSubmit({}, this.callback)

    if(emptyBranchs) this.toggleFilters(true)

    window.addEventListener('resize', () => this.updateDimensions())

    if (fitTableInScreen)
      window.addEventListener('resize', () => this.forceUpdate())
  }

  updateDimensions() {

    if(isEmpty(this.state.dataList)) {
      const noDataHeightDimensionSmall = (window.innerHeight * 70) / 100
      this.setState({noDataHeight: noDataHeightDimensionSmall})
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.columns !== this.props.columns) {
      this.checkProps()
    }
    if(!this.state.dateStart && !this.state.dateEnd ) {
      const {dtRange} = this.state.formData

      if(Array.isArray(dtRange)) {
        const dateStart = moment(dtRange[0].substring(0,10)).format("DD/MM/YYYY")
        const dateEnd = moment(dtRange[1].substring(0,10)).format("DD/MM/YYYY")
        this.setState({dateStart, dateEnd})

      }
    }

    if (!prevProps.update && this.props.update) {
      this.getData()
    }

    if(prevState.analyticsOptions !== this.state.analyticsOptions) {

      this.getData()
    }

    if(prevState.optionSize !== this.state.optionSize) {
      this.setState({page: 1})
      this.getData(true)
    }

  }

  checkScroll() {
    if (window.pageXOffset !== this.state.lastScroll) {
      this.setState({ lastScroll: window.pageXOffset })
      document.querySelector(
        '.part-overflow .headers'
      ).style.transform = `translateX(-${window.pageXOffset}px)`
    }
  }

  checkProps() {
    const headers = []
    const {  order, defaultOrder, limit } = this.props
    if (limit) {
      this.setState({ limit })
    }

    if (order) {
      this.setState({ order: true })
    }

    if (defaultOrder) {
      this.setState({ orderField: defaultOrder })
    }

    this.setState({ headers })
  }

  onSubmit(form) {
    this.setState({firstFetch: false})
    const {dtRange} = this.state.formData


    if(Array.isArray(dtRange)) {
      const dateStart = moment(dtRange[0].substring(0,10)).format("DD/MM/YYYY")
      const dateEnd = moment(dtRange[1].substring(0,10)).format("DD/MM/YYYY")
      this.setState({dateStart, dateEnd})

    }

    this.toggleFilters(false)


    if(this.state.showGraph) {
      const body = this.getBody(true)
      this.props.fetchGraphData(body)
      return;
    }

    this.setState({ formData: form, showTable: true, page: 1 }, () => {
      this.getData()
    })
  }

  onPageChange(page) {
    this.setState({ page }, () => {
      this.getData()
    })
  }


  getBody(resetPage = false) {
    const { optionSize, page, order, orderField, orderDirection, formData } = this.state
    const body = formData
    body.page = resetPage === true ? 1 : page
    body.limit = optionSize
    if(resetPage) {
      this.getSize(10)
    }
    if (order) {
      body.order = orderField
      body.orderDirection = orderDirection
    }
    return body

  }

  getData(resetPage = false) {
    const { optionSize, page, order, orderField, orderDirection, formData } = this.state
    const { showSpinner } = this.props

    if(!this.state.showGraph) showSpinner()

    const body = formData

    body.page = resetPage === true ? 1 : page
    body.limit = optionSize

    if (order) {
      body.order = orderField
      body.orderDirection = orderDirection
    }

    const option = this.state.analyticsOptions.find(op => op.isActive)

    this.props.onSubmit(body, this.callback, option.value )


  }

  callback = (data) => {
    const { optionSize } = this.state
    const { hideSpinner } = this.props

    const { total } = data
    const pages = total ? Math.ceil(total / optionSize) : 0

    this.setState({ response: data, pages, dataList: data.data }, () => {
      hideSpinner()
    })
  }

  onExport() {
    const { showSpinner, hideSpinner, isFlux } = this.props


    if(!isFlux) showSpinner()

    this.props.onExport(() => {
      hideSpinner()
    })
  }

  onExportGraph() {
    const { showSpinner, hideSpinner } = this.props

    showSpinner()
    this.props.onExportGraph(() => {
      hideSpinner()
    })
  }

  order(field, direction) {

      this.setState(
        {
          orderField: field,
          orderDirection: direction,
          page: 1,
        },
        () => this.getData()
      )

  }

  toggleFilters(op) {
    this.setState({ showFilters: op })

    document.querySelector('body').style.overflow = op ? 'hidden' : 'auto'
  }



  handleAnalyticsOptions = (name) => {

    const {analyticsOptions} = this.state

    this.setState({
      analyticsOptions: analyticsOptions.map(op => op.name === name ? {...op, isActive: true} : {...op, isActive: false})
    })
}

getSize(size) {
  this.setState({optionSize: size})

}

  render() {
    const {
      showTable,
      showFilters,
      dataList,
      shadowWidth
    } = this.state
    const {
      fields,
      onExport,
      topLeftPart,
      user,
      translate,
      analyticsDetails,

    } = this.props

    const changeOrder = (field,direction) => this.order(field,direction)

    const countItems = () => {
      const {page, optionSize} = this.state

      if(page === 1) return 1

      return page === 1 ? 1 : ((page - 1) * optionSize) + 1
    }

    const changeScreen = (isGraph) => {
        const{ fetchGraphData } = this.props
        this.setState({showGraph: isGraph})
        if(isGraph && !this.state.firstFetch) {
          const body = this.getBody()
          this.setState({firstFetch: true}, () => fetchGraphData(body))
        }

        if(!isGraph && !this.state.firstFetch) {
          this.setState({page: 1}, () => this.getData())
          this.setState({firstFetch: true})
        }
    }

    return (
      <Fragment>

      <div className='chart-container'>
        <div className={`content ${showTable ? 'no-margin' : '' }`}>
            <div
              className={`filters-overlay ${
                showFilters && showTable ? 'show' : ''
              }`}
            />
            <div
            style={{marginTop: '1px', borderRadius: '8px', overflow:'auto'}}
              className={`filters ${showTable ? 'fixed' : ''} ${
                showFilters ? 'open' : ''
              }`}
            >
              <div className='close' style={{...(analyticsDetails && { right: 43 })}} onClick={() => this.toggleFilters(false)}>
                <img src={CloseSVG} />
              </div>
              <h2>{translate('commonReport.filters')}</h2>
              
                <Form
                  showFilter={this.state.showFilters}
                  cleanFilters={showTable}
                  fields={fields || []}
                  onSubmit={(form) => this.onSubmit(form)}
                  user={user}
                  translate={translate}
                  value={[]}
                />

            </div>

        </div>
      </div>

      {!this.state.showGraph &&
      <div className={`common-report new-common`}>
        <div className='title'>
          <h1>{this.props.title}</h1>
        </div>
        <div className={`content ${showTable ? 'no-margin' : '' }`}>

          <div className={`top ${!showTable ? 'hidden' : ''}`}>
            <div style={{width: 'unset'}} className='left'>{topLeftPart && topLeftPart()}
              {this.props.backToVision &&

                <Button
                onClick={() => browserHistory.push('/analytics-new')}
                className='btn geral-vision'
                svgIcon
                svgComponent={< GeralVisionSVG className='eye-svg' />}
                text={translate('commonReport.backGeralVision')} />
              }

            </div>

            { !this.props.label && !this.props.backToVision && !this.props.hideSpan && <span className='report-top-data' style={{float:"left", marginTop: '13px', marginLeft: '11px'}}>{this.state.dateStart} - {this.state.dateEnd}</span>}
            {this.props.label && <span className='report-top-data' style={{float:"left", marginTop: '13px', marginLeft: '11px'}}>{this.props.label}</span>}
            <div style={{float: "right", width: "unset"}} className='right'>


              {typeof onExport === 'function' && (
                <button
                  style={{backgroundColor: !this.state.showGraph && isEmpty(dataList) && "#D3D2D6", color: !this.state.showGraph && isEmpty(dataList) && "#BAB6BC", cursor: !this.state.showGraph && isEmpty(dataList) && "not-allowed"}}
                  disabled={!this.state.showGraph && isEmpty(dataList)}
                  className='btn download'
                  onClick={() => this.onExport()}
                >
                  <img src={!this.state.showGraph && isEmpty(dataList) ? DownloadGraySVG :  DownloadSVG} />
                  <span>{translate('commonReport.download')}</span>
                </button>
              )}


              {this.props.graphComponent && !this.state.showGraph &&
                 <Button
                 className='btn'
                 onClick={() => changeScreen(true)}
                 svgIcon
                 svgComponent={< GraphSVG className={'svg-align-report'} />}
                 text={translate('graphic_button_label')} />
              }
              {this.props.graphComponent && this.state.showGraph &&
                <Button
                 className='btn'
                 onClick={() => changeScreen(false)}
                 svgIcon
                 svgComponent={< GraphSVG className={'svg-align-report'} />}
                 text={"Visualizar tabela"} />
              }


              <button className='btn' onClick={() => this.toggleFilters(true)}>
                <img src={FilterSVG} />
                <span>{translate('commonReport.filters')}</span>
              </button>
            </div>

          </div>

        </div>

        {
          !this.state.showGraph && showTable && isEmpty(dataList) && <div style={{height: this.state.noDataHeight}} className='relatory-no-data'> <span>{this.props.customEmptyText ? "Não há dados no filtro selecionado"  : "Sem dados"} </span> </div>
        }
        { !this.state.showGraph && showTable && !isEmpty(dataList) &&
        <>
          <div 
            ref={this.myRef} 
            style={{height: '1px', width: `${shadowWidth}px` }} 
            className="shadow">&nbsp;
          </div>

          <div style={{...WRAPPER_TABLE_RELATORY_STYLES}} className='wrapper-table-relatory'>

                <NewRelatoryTable 
                  breakWord={this.props.breakWord} 
                  defaultOrder={this.props.defaultOrder} 
                  columnsDefault={this.props.columns} 
                  shadowRef={this.myRef} 
                  setShadowWidth={(width) => this.setState({shadowWidth: width})} 
                  changeOrder={changeOrder} 
                  dataList={dataList} 
                  translate={translate}  
                />

                <div className='box-footer-shadow'>&nbsp; </div>
                {showTable && (
                  <Row className="new-relatory-row" >
                    <Col className="align-center margin-bottom ">

                      <NewPagination
                      navClass='pagination new-relatory'
                      count={this.state.response.total}
                      current={this.state.page}
                      getPage={(e) => {
                        this.onPageChange(e)
                      }}
                      pages={this.state.pages}
                      />

                      <div  className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
                          <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}
                          </Col>

                          <Col xs={4}>
                                <SizeSelect
                                  components={{DropdownIndicator}}
                                  isSearchable={false}
                                  styles={colourStyles}
                                  classNamePrefix='react-select'
                                  onChange={(option) => this.getSize(option.value)}
                                  options={PAGINATION_OPTIONS}
                                  value={PAGINATION_OPTIONS.find((i) => i.value === this.state.optionSize)}
                                  menuPlacement='top'
                                />
                          </Col>
                      </div>

                      <div style={{float: 'left'}} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
                              <Col >{`
                                ${translate('pagination.size.show')}
                                ${countItems()} - ${this.state.page * this.state.optionSize > this.state.response.total ? this.state.response.total : this.state.page * this.state.optionSize }
                                ${translate("pagination.size.of")}
                                ${this.state.response.total}
                                ${translate("pagination.size.items")}`}
                              </Col>
                      </div>

                    </Col>
                  </Row>

                )}

          </div>
        </>}

      </div>
      }

      {this.state.showGraph &&
        <div className='chart-container'>

          <div className='chart-report'>
            <div className='title'>
              <h1>{this.props.title}</h1>
            </div>

            {!this.props.backToVision || !this.props.hideSpan && (
              <span className='report-top-data'
                    style={{ float: "left", marginTop: '13px', marginLeft: '27px' }}>
                {this.state.dateStart} - {this.state.dateEnd}
              </span>
            )}

          <div className='chart-actions'>

            <button
                    className='btn download dark-btn'
                    onClick={() => {
                      this.onExport()
                    }}
                  >
                    <img src={DownloadSVG} />
                    <span>{translate('commonReport.download')}</span>
                  </button>

            <Button
                  className='btn light-btn'
                  onClick={() => changeScreen(false)}
                  svgIcon
                  svgComponent={< TableSVG className={'svg-align-report'} />}
                  text={translate('table_button_label')} />

              <button className='btn light-btn' onClick={() => this.toggleFilters(true)}>
                  <img src={FilterSVG} />
                  <span>{translate('commonReport.filters')}</span>
              </button>

          </div>

          </div>
          {this.props.graphComponent()}
        </div>}

      </Fragment>

    )
  }
}

CommonReport.propTypes = {
  showTable: PropTypes.bool,
  title: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  columns: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onExport: PropTypes.func,
  onCancel: PropTypes.func,
  fitTableInScreen: PropTypes.bool,
  order: PropTypes.bool,
  defaultOrder: PropTypes.string,
  topLeftPart: PropTypes.any,
  user: PropTypes.object,
  label: PropTypes.string,
  isFlux: PropTypes.bool,
  translate: PropTypes.func.isRequired,
  limit: PropTypes.number,
  hardOrder: PropTypes.string,
  wrapOnHeaderTextOverflow: PropTypes.bool,
  emptyReportMsg: PropTypes.string,
  update: PropTypes.bool,
  showSpinner: PropTypes.func,
  hideSpinner: PropTypes.func,
  backToVision: PropTypes.bool,
  analyticsDetails: PropTypes.bool,
  submitOnRender: PropTypes.bool,
  setMissionColumns: PropTypes.func,
  emptyBranchs: PropTypes.bool,
  ignoreSameValues: PropTypes.bool,
  graphComponent: PropTypes.func,
  firstFetch: PropTypes.bool,
  fetchGraphData: PropTypes.func,
  onExportGraph: PropTypes.func,
  breakWord: PropTypes.bool,
  customEmptyText: PropTypes.bool,
  hideSpan: PropTypes.bool 
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...spinnerActions },
    dispatch
  )

export default connect(() => ({}), mapDispatchToProps)(CommonReport)
export { CommonReport }
